'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCoverage = isCoverage;
exports.checkCoverage = checkCoverage;
exports.isDomain = isDomain;
exports.checkDomain = checkDomain;

var _constants = require('./constants.js');

function isCoverage(obj) {
  return obj.type === _constants.COVERAGE;
}

function checkCoverage(obj) {
  if (!isCoverage(obj)) {
    throw new Error('must be a Coverage');
  }
}

function isDomain(obj) {
  return obj.type === _constants.DOMAIN;
}

function checkDomain(obj) {
  if (!isDomain(obj)) {
    throw new Error('must be a Domain');
  }
}